export function ticketAppliesToEvent(ticket = {}, {
  isRecurring = false,
  ticketPaymentBasis = '',
  occurrenceId = null,
} = {}) {
  const coverageType = ticket.coverageType || 'event';
  if (!isRecurring) return coverageType === 'event';
  if (ticketPaymentBasis === 'whole_series') return coverageType === 'series';
  return coverageType === 'occurrence' && ticket.occurrenceId === occurrenceId;
}

export function remainingRefundableMinor(ticket = {}) {
  return Math.max(0, Number(ticket.amountTotal || 0) - Number(ticket.refundedAmount || 0));
}
